.n{align-items:center;}